export const WHITELIST_USER =
  "https://us-central1-blobit.cloudfunctions.net/whiteListUser";

export const CREATE_TEACHER =
  "https://us-central1-blobit.cloudfunctions.net/createTeacher";

export const CREATE_STUDENT =
  "https://us-central1-blobit.cloudfunctions.net/createStudent";

export const DELETE_STUDENT =
  "https://us-central1-blobit.cloudfunctions.net/deleteStudent";

export const GET_STUDENTS =
  "https://us-central1-blobit.cloudfunctions.net/getStudents";

export const GET_TEACHERS =
  "https://us-central1-blobit.cloudfunctions.net/getTeachers";

export const DELETE_TEACHER =
  "https://us-central1-blobit.cloudfunctions.net/deleteTeacher";

export const EVENT_FETCHING =
  "https://us-central1-blobit.cloudfunctions.net/eventFetching";

export const CLEAR_EVENT =
  "https://us-central1-blobit.cloudfunctions.net/clearEvent";

export const CREATE_EVENT =
  "https://us-central1-blobit.cloudfunctions.net/createEvent";

export const GET_STUDENT_PERFORMANCE =
  "https://us-central1-blobit.cloudfunctions.net/getStudentPerformance";

export const GET_STUDENT_TASK_STATUS =
  "https://us-central1-blobit.cloudfunctions.net/getStudentTaskStatus";

export const CREATE_PIECE =
  "https://us-central1-blobit.cloudfunctions.net/createPiece";

export const DELETE_PIECE =
  "https://us-central1-blobit.cloudfunctions.net/deletePiece";

export const FETCH_PIECES =
  "https://us-central1-blobit.cloudfunctions.net/fetchPieces";

export const UPDATE_PIECE_STATUS =
  "https://us-central1-blobit.cloudfunctions.net/updatePieceStatus";

export const CREATE_RANDOM_MESSAGE =
  "https://us-central1-blobit.cloudfunctions.net/createRandomMessage";

export const DELETE_RANDOM_MESSAGE =
  "https://us-central1-blobit.cloudfunctions.net/deleteRandomMessage";

export const GET_RANDOM_MESSAGES =
  "https://us-central1-blobit.cloudfunctions.net/getRandomMessage";

export const REMOVE_RANDOM_MESSAGE =
  "https://us-central1-blobit.cloudfunctions.net/deleteRandomMessage";

export const UPDATE_RATING_AND_MESSAGE =
  "https://us-central1-blobit.cloudfunctions.net/updateRatingAndMessage";

export const FETCH_SESSIONS =
  "https://us-central1-blobit.cloudfunctions.net/fetchSession";

export const CREATE_SESSION =
  "https://us-central1-blobit.cloudfunctions.net/createSession";

export const DELETE_SESSION =
  "https://us-central1-blobit.cloudfunctions.net/deleteSession";

export const FETCH_EVENTS_BY_SESSIONID =
  "https://us-central1-blobit.cloudfunctions.net/fetchEventsBySessionId";

export const UPDATE_SESSION =
  "https://us-central1-blobit.cloudfunctions.net/updateSession";

export const DELETE_SESSION_AND_EVENTS =
  "https://us-central1-blobit.cloudfunctions.net/deleteSession";

export const UPDATE_TEACHER_MESSAGE =
  "https://us-central1-blobit.cloudfunctions.net/updateTeacherMessage";

export const TEACHER_OVERALL_REPORT =
  "https://us-central1-blobit.cloudfunctions.net/fetchAllStudentsOverallReport";

export const PUNCTUALITY_DATE_WISE =
  "https://us-central1-blobit.cloudfunctions.net/getPunctualityDateWise";
